import { ReactNode } from 'react';
import { useSelector } from '../../../reduxToolkit/typedRedux';
import MessagingCenterModal from '../templates/VystemLight/messaging/MessagingCenterModal';
import ProfileFormModal from '../templates/VystemLight/profile/ProfileFormModal';
import ProfileInfoModal from '../templates/VystemLight/profile/ProfileInfoModal';
import AgendaEntryDetailsModal from '../templates/VystemLight/UIComponents/AgendaUiComponent/AgendaEntryDetailsModal';
import { SpeakerModal } from '../templates/VystemLight/UIComponents/SpeakersUiComponent/SpeakerModal';

const MobilePreviewWrapper = ({ children }: { children: ReactNode }) => {
  const isMobilePreview = useSelector((state) => state.common.isMobilePreview);

  return (
    <div className={`w-full flex flex-row justify-center ${isMobilePreview ? 'bg-[#64748b]' : 'bg-transparent'} relative`}>
      <div className={`@container ${isMobilePreview ? 'w-[425px] shadow-xl overflow-clip' : 'w-screen'} container_class`}>
        {isMobilePreview && (
          <>
            <MessagingCenterModal />
            <ProfileInfoModal />
            <ProfileFormModal />
            {/* <ProfileStatusModal /> */}
            <SpeakerModal />
            <AgendaEntryDetailsModal />
          </>
        )}
        {children}
      </div>
    </div>
  );
};
export default MobilePreviewWrapper;
